import { render, staticRenderFns } from "./AppConfirmDialog.vue?vue&type=template&id=b3765012&scoped=true"
import script from "./AppConfirmDialog.vue?vue&type=script&lang=js"
export * from "./AppConfirmDialog.vue?vue&type=script&lang=js"
import style0 from "./AppConfirmDialog.vue?vue&type=style&index=0&id=b3765012&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3765012",
  null
  
)

export default component.exports